import './StoreDetail.scss';
import { useEffect, useState } from 'react';
import axios from "axios";
import { useHistory, Link } from 'react-router-dom'
import CHeader from '../../app-components/CHeader';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import ShimmerC from '../../app-components/ShimmerC';
import Productitem from '../../app-components/Productitem';
import CFooter from '../../app-components/CFooter';
import Alert from 'react-bootstrap/Alert'
import storeBlack from '../../assets/storeBlack.png'
import {globleAPI as Global} from '../../globals'
import slugify from 'react-slugify';

function StoreDetail(props: any) {

  const [storesData, setstoresData] = useState<any>([])
  const [store_details, setstore_details] = useState<any>([])
  const [showAlert, setshowAlert] = useState(false)
  const [FollowStore, setFollowStore] = useState<any>()
  const [status, setstatus] = useState('')
  const [storeOtherData, setstoreOtherData] = useState<any>([])
  const [store_followers, setstore_followers] = useState<any>([])
  const [token] = useState(localStorage.getItem('token') || '')
  const [userid] = useState(localStorage.getItem('userid') || '')

  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0)
     getStoreDetail()
  }, [])

  const getStoreDetail = () => {
 
    axios
      .get(Global.WebGetStoreDetailsV2+"?user_id=" + props.location.state[0] + "&page=" + 1)
      .then(response => {
        setFollowStore(response.data.is_followed)
        setstoresData(response.data.AllProducts.data)
        setstore_details(response.data.store_details[0])
        setstoreOtherData(response.data)
        setstore_followers(response.data.store_followers.length)
      })
      .catch(function (error) {
        console.log('response if the api is errror =', error)
      });
  }

  const followStore = () => {
    if(userid == " "){
      setshowAlert(true)
      setstatus('Please login first to follow the store')
    }else{
      let formdata = new FormData();
      formdata.append("id", userid);
    axios({
      method: "post",
      url: Global.FOLLOW_STORE + token,
      data: formdata,
    })
    .then(response => {
      if(response.data.status == 200){
        getStoreDetail()
      }else if(response.data.status == 201){
        getStoreDetail()
      }
        })
        .catch(function (error) {
          console.log('groupscreate', error)
        });
    
    }
   
  }

  const moveToDetailScreen = (data: any) => {
    history.push('/product-detail/'+data.id + '/'+slugify(data.name))
  }

  return (
    <div>
      <CHeader></CHeader>
      {showAlert == true ? (
        <div className='d-flex justify-content-center' >
          <Alert style={{ marginTop: '30vh', position: 'absolute', zIndex: 1, width: 'auto', paddingLeft: '10%', paddingRight: '10%' }} variant="primary" show={showAlert}  >
            <Alert.Heading style={{ textAlign: 'center' }} ></Alert.Heading>
            <p style={{}} >{status}</p>
          </Alert>
        </div>
      ) : null}
      <div className="page-left-padding page-right-padding bg-color-light"  >
        <div className="page-left-padding page-right-padding cm-l-25 cm-r-25 cp-t-40 cp-b-60"   >
          <div className="cp-b-40" >
            <Breadcrumbs separator="›" aria-label="breadcrumb">
              <Link style={{ color: 'black' }} className="main-font" to="/">Home</Link>
              <Typography className="primary-color main-font" color="textPrimary">All Retail Stores</Typography>
              <Typography className="primary-color main-font" color="textPrimary">Store Profile</Typography>
            </Breadcrumbs>
          </div>
          <div style={{ backgroundColor: 'white' }} >
            <div className="cp-20 d-flex flex-row" >
              <div className="store-img-container col-md-3 " style={{ backgroundColor:'white' }} >
                {store_details?.profile_pic !== null ?(
    <img className="store-image" alt='img' src={'https://lesfemmestesting.dominioninc.org/public/uploads/images/' + store_details?.profile_pic} ></img>
                ):(
                  <img className="store-image" alt='img' src={storeBlack} ></img>
                )}
              
              </div>
              <div className="d-flex justify-content-between col-md-9">
                <div>
                  <label className="f-22 cp-t-15 cp-b-15 font-weight-bold main-font primary-color" >{store_details?.store_name}</label>
                  <br />
                  {FollowStore == true ?(
 <label onClick={()=>followStore()} className="f-18 cp-t-10 cp-b-10 cp-l-20 cp-r-20 font-weight-bold main-font  bg-color-primary" style={{ color: 'white', borderRadius: 5 }} >Unfollow</label>
                  ):(
                    <div onClick={()=>followStore()} >
                      <label  className="f-18 cp-t-10 cp-b-10 cp-l-20 cp-r-20 font-weight-bold main-font  bg-color-primary" style={{ color: 'white', borderRadius: 5 }} >Follow</label>
                      </div>
                  )

                  }
                 
                </div>
                <div className="d-flex flex-column  align-self-center" >
                  <label className="f-18  font-weight-bold main-font " >{storeOtherData?.total_products} Products</label>
                  <label className="f-20 font-weight-bold main-font primary-color" style={{ color: 'white', borderRadius: 5 }} >{store_followers} Followers</label>
                </div>
              </div>
            </div>
            <div className="border-top border-bottom" >
              <label className="f-18 font-weight-bold main-font label cp-20 cp-l-50 " style={{ borderRadius: 5 }} >Authentic Luxury Items</label>
            </div>
            {storesData.length >= 1 ? (
              <div className='row cp-26 '>
                {storesData.map((stores: any) => (
                  <div onClick={() => moveToDetailScreen(stores)}  className='col-md-4 col-lg-3 col-sm-6 col-6  '>
                    <Productitem DataofProduct={stores} />
                  </div>
                ))
                }
              </div>
            ) : (
              <div className='row' style={{  height: '100vh' }}>
                <ShimmerC allproducts='yes' />
                <ShimmerC allproducts='yes' />
              </div>
            )}
          </div>
        </div>
      </div>
      <CFooter/>
    </div>
  );
}
export default StoreDetail;
